import {NgModule} from '@angular/core';
import {Scanner3dCommonModule} from './common/scanner3dCommon.module';
import {Scanner3dAccountModule} from './account/scanner3dAccount.module';
@NgModule({
    imports: [
        Scanner3dCommonModule,
        Scanner3dAccountModule,
    ]
})
export class Scanner3dModule {}

